/**
 * Income-range bands for the member profile (CLAUDE.md "income range [select bands]"). Keep in
 * sync with backend/app/profile_options.py. Each band's representative annual income is used
 * only to pre-fill calculator inputs — the band itself is what's saved.
 */
export const INCOME_RANGES = [
  { value: "lt_5l", label: "Less than ₹5 Lakh", representativeAnnualIncome: 400_000 },
  { value: "5l_10l", label: "₹5 Lakh – ₹10 Lakh", representativeAnnualIncome: 750_000 },
  { value: "10l_25l", label: "₹10 Lakh – ₹25 Lakh", representativeAnnualIncome: 1_750_000 },
  { value: "25l_50l", label: "₹25 Lakh – ₹50 Lakh", representativeAnnualIncome: 3_750_000 },
  { value: "50l_1cr", label: "₹50 Lakh – ₹1 Crore", representativeAnnualIncome: 7_500_000 },
  { value: "gt_1cr", label: "More than ₹1 Crore", representativeAnnualIncome: 15_000_000 },
];

export function representativeAnnualIncome(incomeRangeValue) {
  return INCOME_RANGES.find((r) => r.value === incomeRangeValue)?.representativeAnnualIncome;
}
